__turbopack_context__.v({
  "cskTeamContainer": "Squad-module-scss-module__8jR1qa__cskTeamContainer",
  "list-container": "Squad-module-scss-module__8jR1qa__list-container",
  "loader-container": "Squad-module-scss-module__8jR1qa__loader-container",
  "pageTitle": "Squad-module-scss-module__8jR1qa__pageTitle",
  "player-list-container": "Squad-module-scss-module__8jR1qa__player-list-container",
});
